import React from "react";
import { Info } from "lucide-react";

interface StatCardProps {
  icon: React.ReactNode;
  title: string;
  value: string | number;
  iconBgColor: string;
  iconColor: string;
  onInfoClick?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({
  icon,
  title,
  value,
  iconBgColor,
  iconColor,
  onInfoClick,
}) => (
  <div className="bg-white border border-gray-200 rounded-lg p-5 flex items-start gap-4">
    <div
      className={`${iconBgColor} ${iconColor} p-2.5 rounded-lg flex items-center justify-center flex-shrink-0`}
    >
      {icon}
    </div>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-1.5 mb-1">
        <p className="text-xs font-medium uppercase tracking-wide text-gray-400">{title}</p>
        {onInfoClick && (
          <button
            onClick={onInfoClick}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label={`Info about ${title}`}
          >
            <Info size={12} />
          </button>
        )}
      </div>
      <p className="text-3xl font-semibold text-gray-900 tracking-tight">{value}</p>
    </div>
  </div>
);

export default StatCard;
